module.exports = __webpack_public_path__ + "img/11order.36590d49.png";